import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';

import { globalStyles } from 'Theme';
import { t } from 'Locale';
import BigButton from 'LocalGluons/components/BigButton';

import defaultStyles from './NoRecordingsContent.jss';

const NoRecordingsContent = ({ onTvGuidePress }) => (
    <View style={defaultStyles.container}>
        <View style={defaultStyles.contentConteiner}>
            <Text style={globalStyles.title}>{t('COMMON.RECORDINGS_PLAN_TXT')}</Text>
            <Text style={globalStyles.secondaryDescription}>
                {t('COMMON.RECORDINGS_PLAN_DESCRIPTION')}
            </Text>
            <BigButton
                style={{
                    button: defaultStyles.button
                }}
                iconName="tv_guide"
                heading={t('COMMON.VIEW_TV_GUIDE')}
                onPress={onTvGuidePress}
                testID="epg_button"
            />
        </View>
    </View>
);

NoRecordingsContent.propTypes = {
    onTvGuidePress: PropTypes.func.isRequired
};

export default NoRecordingsContent;
